import { createContext, useContext, useState } from "react";

export type ExcelData = {
  ean: string;
  productName: string;
  amount: string;
  metalBusiness: string | undefined;
  metalConsumer: string | undefined;
  glassBusiness: string | undefined;
  glassConsumer: string | undefined;
  plasticBusiness: string | undefined;
  plasticConsumer: string | undefined;
  paperBusiness: string | undefined;
  paperConsumer: string | undefined;
  woodBusiness: string | undefined;
  woodConsumer: string | undefined;
};

const ExcelContext = createContext<{
  excelData: ExcelData[];
  setExcelData: React.Dispatch<React.SetStateAction<ExcelData[]>>;
}>({
  excelData: [],
  setExcelData: () => {},
});

export const ExcelProvider = ({ children }) => {
  const [excelData, setExcelData] = useState<ExcelData[]>([]);

  return (
    <ExcelContext.Provider value={{ excelData, setExcelData }}>
      {children}
    </ExcelContext.Provider>
  );
};

export const useExcelData = () => useContext(ExcelContext);
